<template>
    <el-dialog
        class="import"
        :visible.sync="importVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="600px"
        :title="title ? title : '批量导入'"
        append-to-body
    >
        <div class="bulkText">
            请选择需要导入的Excel文件
        </div>
        <el-upload
            style="display:flex;margin:14px 0;"
            :limit="1"
            class="upload-demo"
            ref="upload"
            action
            :file-list="fileList"
            :http-request="uploadFile"
            :on-remove="handleRemove"
        >
            <el-button slot="trigger" size="small" type="primary" plain
                >批量导入</el-button
            >
        </el-upload>
        <a
            v-if="this.temSrc"
            :href="wwwUrl + '/api' + temSrc"
            style="color:blue;font-size:12px;display:flex;line-height:2"
            >点击：下载范例模板</a
        >
        <div style="display:flex;text-align:left;line-height:1.6">
            请按照数据模板的格式准备导入数据，模板中的表头名称不可更改，表头行不能删除。
        </div>
        <div
            style="display:flex;text-align:left;line-height:1.6;padding-bottom:16px;"
        >
            导入规则说明：
            <br />文件后缀名必须为：xls或xlsx(即Excel格式)，文件大小不大于5M
        </div>
        <ul class="condition" v-if="success_num > 0 || failure_num > 0">
            <li>导入情况</li>
            <li style="color:#67C23A">成功:{{ success_num }}条已创建</li>
            <li style="color:#eb5202">失败:{{ failure_num }}条创建失败</li>
            <li v-for="item in errArray" :key="item">
                {{ item }}
            </li>
        </ul>
    </el-dialog>
</template>
<script>
import * as oaApi from "@/http/oaApi.js";
import { mapState } from "vuex";
export default {
    data() {
        return {
            success_num: 0,
            failure_num: 0,
            errArray: [],
        };
    },
    methods: {
        // 批量上传
        uploadFile(file) {
            let formData = new FormData();
            formData.append("files", file.file);
            oaApi[this.methodName](formData, "post").then(res => {
                this.$parent[this.parentFuncName]();
                if (res.code == 200 && res.data.failure_num == 0) {
                    this.$message.success("上传成功");
                } else if (res.code == 200) {
                    this.$message.warning("上传数据有误");
                } else {
                    this.$message.error("上传失败");
                    formData.delete("files");
                    // this.$message.error(res.msg);
                }
                this.success_num = res.data.success_num
                    ? res.data.success_num
                    : 0;
                this.failure_num = res.data.failure_num
                    ? res.data.failure_num
                    : 0;
                this.errArray = res.data.errors ? res.data.errors : [];
            });
        },
        // 弹窗关闭
        closeDialog() {
            this.success_num = 0;
            this.failure_num = 0;
            this.errArray = [];
            this.$refs.upload.clearFiles();
            this.$emit("update:importVisible", false);
        },
        handleRemove(file, fileList) {
            this.$refs["upload"].clearFiles();
            this.success_num = 0;
            this.failure_num = 0;
            this.errArray = [];
        }
    },
    computed: {
        ...mapState({
            wwwUrl: state => state.index.wwwUrl,
        }),
    },
    props: {
        importVisible: Boolean,
        methodName: String,
        parentFuncName: String,
        temSrc: String,
        title: String
    },
};
</script>
<style lang="scss">
.import {
    .bulkText {
        text-align: left;
    }
    .condition {
        border-top: 1px solid #ddd;
        width: 100%;
        li {
            text-align: left;
            line-height: 2;
        }
    }
}
</style>
